import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FuncionamentoDireitaComponent } from './funcionamento-direita.component';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';

@NgModule({
  declarations: [
    FuncionamentoDireitaComponent
  ],
  imports: [
    TranslateModule,
    CommonModule,
    RouterModule,
    LocalizeRouterModule
  ],
  exports: [
    FuncionamentoDireitaComponent
  ]
})

export class FuncionamentoDireitaModule { }
